module.exports = __webpack_public_path__ + "img/slot-machine-front.7793baf5.png";